import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, PropType } from 'vue';
import { useStore } from '@/composables/use-globals';
import { Member } from '@/models/member';
import { ageFormatted } from '@/services/utils';
import { useFeature } from '@/composables/use-feature';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterMember',
  props: {
  member: {
    type: Object as PropType<Member>,
    required: true,
  },
},
  emits: ['showNote'],
  setup(__props, { emit }) {

const store = useStore();

const enableMemberNotes = useFeature(store, 'ENABLE_MEMBER_NOTES');



const telephoneDialog = ref(false);

const getAgeFormatted = (dob: string | undefined): string => {
  return ageFormatted(dob) as string;
};

const showTelephoneNumbers = computed(() => {
  return store.getters['auth/isFeatureEnabled']('SHOW_CONTACT_NUMBERS');
});

function toggleTelephoneDialog() {
  telephoneDialog.value = !telephoneDialog.value;
}
function toggleNote() {
  if (enableMemberNotes.value) {
    emit('showNote');
  }
}

function callNumber(number: string) {
  window.open(`tel:${number}`, '_self');
}

function canPhotographMember(member: Member) {
  return ['private_photo_consent', 'public_photo_consent'].some(
    key => member.meta && key in member.meta && member.meta[key].value === 'true'
  );
}

return { __sfc: true,store, emit, enableMemberNotes, telephoneDialog, getAgeFormatted, showTelephoneNumbers, toggleTelephoneDialog, toggleNote, callNumber, canPhotographMember }
}

})